class ComplementaryProducts extends HTMLElement {
  constructor() {
    super();
    this.carousel = null;
  }

  connectedCallback() {
    this.init();
  }

  async init() {
    const url = this.dataset.url;
    const text = await this.fetchProducts(url);
    const html = document.createElement("div");
    html.innerHTML = text;
    const recommendations = html.querySelector(".complementary-products-main");

    if (recommendations && recommendations.innerHTML.trim().length) {
      this.innerHTML = recommendations.innerHTML;
      this.initCarousel(this.querySelector(".splide"));
    } else {
      this.innerHTML = "";
    }
  }

  /**
   * Get the recommended products
   *
   * @param {string} url
   * @returns {Promise} - Shopify response
   */
  async fetchProducts(url) {
    try {
      const response = await fetch(url);

      if (!response.ok) {
        throw new Error(`Cannot fetch products - status ${response.status}`);
      }
      const text = await response.text();
      return text;
    } catch (error) {
      console.error(error);
      return error;
    }
  }

  initCarousel(el) {
    this.carousel = new Splide(el, {
      perPage: 3,
      gap: 10,
      focus: 0,
      pagination: false,
      arrows: false,
    }).mount();
  }
}

if (!customElements.get("complementary-products")) {
  customElements.define("complementary-products", ComplementaryProducts);
}
